import type { DictionaryColumn, FieldType } from '@lens/shared';
import type { FieldLike } from '../../shared/table';

/**
 * dictColumnToField — адаптер DictionaryColumn → FieldLike, чтобы переиспользовать
 * shared/table компоненты (FilterBar, CellEditor, GroupingPopover) с колонками
 * справочника. DictionaryColumn.columnType — подмножество FieldType, поэтому
 * cast безопасен; для отсутствующих в FieldType типов делаем fallback в 'text'.
 */
export function dictColumnToField(col: DictionaryColumn): FieldLike {
  const allowed: FieldType[] = [
    'text',
    'number',
    'boolean',
    'select',
    'multi_select',
    'reference',
    'url',
  ];
  const fieldType = (allowed as string[]).includes(col.columnType)
    ? (col.columnType as FieldType)
    : ('text' as FieldType);

  // Опции select/multi_select в справочнике хранятся как string[], а
  // shared/table CellEditor и renderFieldValue ждут Array<{value,label}>.
  // Без нормализации inline-редактор ячейки строит {value: undefined,
  // label: undefined} для каждой строки → выпадающий список пуст. Приводим к
  // {value,label}; для уже-объектных опций преобразование идемпотентно.
  const rawConfig = (col.config ?? {}) as Record<string, unknown>;
  let config: Record<string, unknown> = rawConfig;
  if (fieldType === 'select' || fieldType === 'multi_select') {
    const opts = Array.isArray(rawConfig.options) ? rawConfig.options : [];
    config = {
      ...rawConfig,
      options: opts.map((o) =>
        typeof o === 'string' ? { value: o, label: o } : o,
      ),
    };
  }

  return {
    slug: col.slug,
    name: col.name,
    fieldType,
    config,
  };
}
